// src/core/layout/SidebarLayoutWidth.tsx

export const SIDEBAR_WIDTH = {
  COLLAPSED: "3rem", // 64px
  EXPANDED: "10rem", // 288px
};

export const CONTENT_PADDING_RIGHT = "0rem"; // = px-6
